import React from "react";

export default function ProtectedRoute({ children, setActiveLink, navLinks }) {

  return React.cloneElement(children, { setActiveLink, navLinks });
}